module.exports = __webpack_public_path__ + "static/media/elements_section1.5710d80f.png";